// src/components/WarehouseList.jsx
import React, { useState, useEffect } from 'react';
import { FaFileAlt, FaBoxes, FaBoxOpen, FaUserTie, FaClipboardList, FaEye, FaEdit, FaTrashAlt, FaAngleLeft, FaAngleRight, FaCaretDown } from 'react-icons/fa';

export default function WarehouseList() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsSmallMobile(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Sample data for warehouse items, matching the image content
    const [warehouseItems, setWarehouseItems] = useState([
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
        { id: '#13445', name: 'Haider zakir', location: 'main shadbagh', manager: 'Hassan ali', contact: '+23 0322 8574734', stockAvailable: 4864, stockShipping: 3465, revenue: '25 lac' },
    ]);

    const styles = {
        mainWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'transparent', // Main background color
            padding: isSmallMobile ? '10px' : (isMobile ? '20px' : '40px'),
            boxSizing: 'border-box',
            fontFamily: 'Arial, sans-serif',
            overflowY: 'auto', // Allow vertical scrolling for the entire component if content is too tall
            overflowX: 'hidden', // Explicitly hide horizontal scrollbar for the wrapper
        },
        warehouseContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1200px',
            backgroundColor: 'transparent',
            padding: '0',
            boxSizing: 'border-box',
            overflow: 'hidden', // Ensures no overflow outside this main container
        },
        headerTitle: {
            fontSize: isSmallMobile ? '20px' : (isMobile ? '24px' : '30px'),
            color: '#000',
            marginBottom: isSmallMobile ? '15px' : '25px',
            fontWeight: 'bold',
            textAlign: 'left',
            padding: '0 10px',
        },
        cardsContainer: {
            display: 'grid',
            gridTemplateColumns: isSmallMobile ? '1fr' : (isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)'),
            gap: isSmallMobile ? '10px' : '15px',
            marginBottom: isSmallMobile ? '15px' : '25px',
            padding: '0 10px',
        },
        card: {
            backgroundColor: '#000',
            borderRadius: '8px',
            padding: isSmallMobile ? '10px' : '15px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            color: '#E5D0A5',
            minHeight: isSmallMobile ? '70px' : '90px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
        },
        cardHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '5px',
        },
        cardTitle: {
            fontSize: isSmallMobile ? '12px' : '14px',
            margin: 0,
            color: '#BBB',
        },
        cardIcon: {
            fontSize: isSmallMobile ? '16px' : '20px',
            color: '#D4AF37',
        },
        cardValue: {
            fontSize: isSmallMobile ? '18px' : '24px',
            fontWeight: 'bold',
            textAlign: 'right',
            margin: 0,
            lineHeight: '1',
        },
        cardItems: {
            fontSize: isSmallMobile ? '10px' : '12px',
            color: '#888',
            textAlign: 'right',
        },
        warehouseListContainer: {
            backgroundColor: '#000',
            borderRadius: '10px',
            padding: isSmallMobile ? '15px' : '20px',
            color: '#E5D0A5',
        },
        listHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            textAlign: isSmallMobile ? 'center' : 'left',
        },
        listTitle: {
            fontSize: isSmallMobile ? '16px' : '20px',
            margin: 0,
            fontWeight: 'bold',
        },
        monthDropdownContainer: {
            position: 'relative',
            display: 'inline-block',
            width: isSmallMobile ? '100%' : 'auto',
            textAlign: isSmallMobile ? 'center' : 'left',
        },
        monthDropdown: {
            padding: '6px 25px 6px 12px',
            borderRadius: '5px',
            border: '1px solid #D4AF37',
            backgroundColor: '#000',
            color: '#E5D0A5',
            fontSize: '12px',
            cursor: 'pointer',
            appearance: 'none',
            width: isSmallMobile ? '70%' : 'auto',
            boxSizing: 'border-box',
        },
        dropdownArrow: {
            position: 'absolute',
            right: isSmallMobile ? '18%' : '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#E5D0A5',
            pointerEvents: 'none',
            fontSize: '10px',
        },
        // Table Wrapper - NO OVERFLOW-X: AUTO, NO PADDING TRICK
        tableWrapper: {
            marginBottom: '15px',
            borderRadius: '8px',
            // No specific overflowX here, relying on table column display
            // and the mainWrapper's overflowY:auto for vertical scroll if content is too long.
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            // No minWidth here either, columns will control sizing
            display: isSmallMobile ? 'block' : 'table', // Table display for larger, block for very small
        },
        tableHeader: {
            backgroundColor: '#1a1a1a',
            color: '#E5D0A5',
            fontSize: '12px',
            textAlign: 'left',
            fontWeight: 'bold',
            display: isSmallMobile ? 'none' : 'table-header-group', // Hide header on small mobile
        },
        th: {
            padding: '12px 5px', // Reduced horizontal padding
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #333',
            // Removed minWidth to let columns adjust, but careful with content
        },
        tableBody: {
            backgroundColor: '#000',
            display: isSmallMobile ? 'block' : 'table-row-group', // Block display for very small mobile
        },
        tableRow: {
            borderBottom: '1px solid #333',
            display: isSmallMobile ? 'block' : 'table-row', // Block display for very small mobile
            marginBottom: isSmallMobile ? '10px' : '0', // Increased vertical space between rows on small mobile
            borderRadius: '8px',
            overflow: 'hidden', // Ensure content within row is clipped
        },
        tableRowHover: {
            backgroundColor: '#1a1a1a',
        },
        td: {
            padding: isSmallMobile ? '8px 10px' : '12px 5px', // Increased vertical, reduced horizontal padding for cells
            verticalAlign: 'middle',
            whiteSpace: 'nowrap', // Prevents text wrapping in cells
            fontSize: '12px',
            color: '#E5D0A5',
            display: isSmallMobile ? 'block' : 'table-cell', // Make cells block on very small mobile
            textAlign: isSmallMobile ? 'right' : 'left', // Align text to right for data on small mobile
            position: 'relative', // For label
            borderBottom: isSmallMobile ? '1px dashed #333' : 'none', // Dashed line between stacked data
            paddingLeft: isSmallMobile ? '40%' : '12px', // Space for the label
        },
        tdBefore: { // For responsive table column labels
            content: 'attr(data-label)',
            position: 'absolute',
            left: '10px',
            width: 'calc(40% - 20px)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 'bold',
            color: '#BBB',
            textAlign: 'left',
            display: isSmallMobile ? 'block' : 'none', // Only show on small mobile
        },
        actionButtons: {
            display: 'flex',
            gap: '5px',
            justifyContent: isSmallMobile ? 'flex-end' : 'flex-start', // Align actions right on small mobile
            alignItems: 'center',
            marginTop: isSmallMobile ? '5px' : '0', // Push actions down on small mobile
        },
        actionButton: {
            backgroundColor: '#333',
            border: '1px solid #E5D0A5',
            borderRadius: '5px',
            padding: '6px 8px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#E5D0A5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease, border-color 0.2s ease',
        },
        actionButtonHover: {
            backgroundColor: '#555',
            borderColor: '#FFF',
        },
        deleteButton: {
            backgroundColor: '#B22222', // Red color for delete
            borderColor: '#B22222',
            color: '#fff',
        },
        deleteButtonHover: {
            backgroundColor: '#CC3333',
            borderColor: '#FF4444',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            padding: '0 5px',
            color: '#E5D0A5',
        },
        paginationControls: {
            display: 'flex',
            gap: '5px',
            flexWrap: 'wrap',
            justifyContent: isSmallMobile ? 'center' : 'flex-start',
        },
        paginationButton: {
            backgroundColor: '#333',
            color: '#E5D0A5',
            border: '1px solid #E5D0A5',
            borderRadius: '5px',
            padding: '6px 10px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.2s ease, border-color 0.2s ease',
            minWidth: '30px',
            textAlign: 'center',
            fontWeight: 'bold',
        },
        paginationButtonActive: {
            backgroundColor: '#D4AF37',
            color: '#000',
            borderColor: '#D4AF37',
        },
        paginationButtonHover: {
            backgroundColor: '#555',
            borderColor: '#FFF',
        },
        paginationText: {
            color: '#E5D0A5',
            fontSize: '12px',
            marginTop: isSmallMobile ? '8px' : '0',
        },
        checkbox: {
            accentColor: '#D4AF37',
            transform: 'scale(1.1)',
            marginRight: '5px',
        }
    };

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.warehouseContainer}>
                <h1 style={styles.headerTitle}>Warehouse</h1>

                {/* Top Cards Section */}
                <div style={styles.cardsContainer}>
                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Total Product Item</h3>
                            <FaFileAlt style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                        <p style={styles.cardItems}>items</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>In Stock Product</h3>
                            <FaBoxes style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                        <p style={styles.cardItems}>items</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Out of Stock Product</h3>
                            <FaBoxOpen style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                        <p style={styles.cardItems}>items</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Total Visited Customer</h3>
                            <FaUserTie style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                        <p style={styles.cardItems}>Last 7 days</p>
                    </div>
                </div>

                {/* All Warehouse List Section */}
                <div style={styles.warehouseListContainer}>
                    <div style={styles.listHeader}>
                        <h2 style={styles.listTitle}>All Warehouse list</h2>
                        <div style={styles.monthDropdownContainer}>
                            <select style={styles.monthDropdown}>
                                <option>This Month</option>
                                <option>Last Month</option>
                                <option>This Year</option>
                            </select>
                            <FaCaretDown style={styles.dropdownArrow} />
                        </div>
                    </div>

                    {/* Table Wrapper - No horizontal scroll for wrapper */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.tableHeader}>
                                <tr>
                                    <th style={styles.th}><input type="checkbox" style={styles.checkbox} /></th>
                                    <th style={styles.th}>Warehouse ID</th>
                                    <th style={styles.th}>Warehouse Name</th>
                                    <th style={styles.th}>Location</th>
                                    <th style={styles.th}>Manager</th>
                                    <th style={styles.th}>Contact Number</th>
                                    <th style={styles.th}>Stock Available</th>
                                    <th style={styles.th}>Stock Shipping</th>
                                    <th style={styles.th}>Warehouse Revenue</th>
                                    <th style={styles.th}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {warehouseItems.map((item, index) => (
                                    <tr
                                        key={index}
                                        style={styles.tableRow}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.tableRowHover.backgroundColor}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        <td style={styles.td}><input type="checkbox" style={styles.checkbox} /></td>
                                        <td style={styles.td} data-label="ID:">{item.id}</td>
                                        <td style={styles.td} data-label="Name:">{item.name}</td>
                                        <td style={styles.td} data-label="Location:">{item.location}</td>
                                        <td style={styles.td} data-label="Manager:">{item.manager}</td>
                                        <td style={styles.td} data-label="Contact:">{item.contact}</td>
                                        <td style={styles.td} data-label="Available:">{item.stockAvailable}</td>
                                        <td style={styles.td} data-label="Shipping:">{item.stockShipping}</td>
                                        <td style={styles.td} data-label="Revenue:">{item.revenue}</td>
                                        <td style={styles.td} data-label="Actions:">
                                            <div style={styles.actionButtons}>
                                                <button
                                                    style={styles.actionButton}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEye />
                                                </button>
                                                <button
                                                    style={styles.actionButton}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    style={{ ...styles.actionButton, ...styles.deleteButton }}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.deleteButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.deleteButton.backgroundColor}
                                                >
                                                    <FaTrashAlt /> {/* Delete Icon */}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div style={styles.paginationContainer}>
                        <div style={styles.paginationControls}>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleLeft />
                            </button>
                            <button
                                style={{ ...styles.paginationButton, ...styles.paginationButtonActive }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonActive.backgroundColor}
                            >
                                1
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                2
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                3
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                4
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                5
                            </button>
                            <span style={styles.paginationText}> ...... </span>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                10
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                        <p style={styles.paginationText}>100 Results</p>
                    </div>
                </div>
            </div>
        </div>
    );
}